import { languages } from '@/constants';
import { ELanguage } from '@/enums';
import { ILanguage } from '@/interfaces';

export const getLocale = (e: ELanguage): ILanguage => {
  switch (e) {
    case ELanguage.ENGLISH:
      return languages[0];
    case ELanguage.KINYARWANDA:
      return languages[1];
    case ELanguage.FRENCH:
      return languages[2];
    default:
      return languages[1];
  }
};
